﻿// 专门给 educator 使用的工具路由（使用统一前缀）
const prefix = "student";

export const toolRoutes = [
  {
    name: `${prefix}-chat`,
    path: "chat",
    meta: { title: "智能聊天", requiresAuth: true, roles: ["student"] },
    component: () => import("@/views/ChatNew.vue"),
  },
  {
    name: `${prefix}-chat-id`,
    path: "chat/:id",
    meta: { title: "智能聊天", requiresAuth: true, roles: ["student"] },
    component: () => import("@/views/ChatNew.vue"),
  },
  // 图片工具
  {
    name: `${prefix}-image-recognize`,
    path: "tool/image-recognize",
    meta: { title: "图像识别" },
    component: () => import("@/views/tools/image/ImageRecognize.vue"),
  },
  {
    name: `${prefix}-image-tagging`,
    path: "tool/image-tagging",
    meta: { title: "图像识别置信度" },
    component: () => import("@/views/tools/image/ImageTagging.vue"),
  },
  {
    name: `${prefix}-image-digital`,
    path: "tool/image-digital",
    meta: { title: "图像数字化实验室" },
    component: () => import("@/views/tools/image/Digitalization.vue"),
  },
  {
    name: `${prefix}-text-ocr`,
    path: "tool/text-ocr",
    meta: { title: "OCR文本识别" },
    component: () => import("@/views/tools/text/TextOcr.vue"),
  },
  {
    name: `${prefix}-handwrite`,
    path: "tool/handwrite",
    meta: { title: "手写识别" },
    component: () => import("@/views/tools/text/Handwrite.vue"),
  },
  {
    name: `${prefix}-text-classify`,
    path: "tool/text-classify",
    meta: { title: "文本分类" },
    component: () => import("@/views/tools/text/TextClassify.vue"),
  },
  {
    name: `${prefix}-text-segment`,
    path: "tool/text-segment",
    meta: { title: "文本分词" },
    component: () => import("@/views/tools/text/TextSegment.vue"),
  },
  {
    name: `${prefix}-face-express`,
    path: "tool/face-express",
    meta: { title: "人脸表情识别" },
    component: () => import("@/views/tools/misc/FaceExpress.vue"),
  },
  {
    name: `${prefix}-face-compare`,
    path: "tool/face-compare",
    meta: { title: "人脸对比" },
    component: () => import("@/views/tools/misc/FaceCompare.vue"),
  },
  {
    name: `${prefix}-image`,
    path: "tool/image",
    meta: { title: "图片生成" },
    component: () => import("@/views/tools/image/ImageGeneration.vue"),
  },
  {
    name: `${prefix}-future-me`,
    path: "tool/future-me",
    meta: { title: "未来的我" },
    component: () => import("@/views/tools/image/FutureMe.vue"),
  },

  // 训练工具
  {
    name: `${prefix}-train-image`,
    path: "tool/train-image",
    meta: { title: "图像训练" },
    component: () => import("@/views/tools/training/TrainImage.vue"),
  },
  {
    name: `${prefix}-train-pose`,
    path: "tool/train-pose",
    meta: { title: "姿势训练" },
    component: () => import("@/views/tools/training/TrainPose.vue"),
  },
  {
    name: `${prefix}-train-audio`,
    path: "tool/train-audio",
    meta: { title: "音频训练" },
    component: () => import("@/views/tools/training/TrainAudio.vue"),
  },
  {
    name: `${prefix}-train-text`,
    path: "tool/train-text",
    meta: { title: "文本训练" },
    component: () => import("@/views/tools/training/TrainText.vue"),
  },
  // 思维工具
  {
    name: `${prefix}-markmap`,
    path: "tool/markmap",
    meta: { title: "AI脑图" },
    component: () => import("@/views/tools/misc/MarkMap.vue"),
  },
  {
    name: `${prefix}-quickdraw`,
    path: "tool/quickdraw",
    meta: { title: "你画AI猜" },
    component: () => import("@/views/tools/image/QuickDraw.vue"),
  },
  {
    name: `${prefix}-quickdrawty`,
    path: "tool/quickdrawty",
    meta: { title: "涂鸦识别" },
    component: () => import("@/views/tools/image/QuickDrawTy.vue"),
  },
  // 语音工具
  {
    name: `${prefix}-tts`,
    path: "tool/tts",
    meta: { title: "语音合成" },
    component: () => import("@/views/tools/audio/DoubaoTTS.vue"),
  },
  {
    name: `${prefix}-asryy`,
    path: "tool/asryy",
    meta: { title: "语音识别" },
    component: () => import("@/views/tools/audio/FunAsrRealtimeyy.vue"),
  },
  {
    name: `${prefix}-asrfy`,
    path: "tool/asrfy",
    meta: { title: "方言识别" },
    component: () => import("@/views/tools/audio/FunAsrRealtimefy.vue"),
  },
  {
    name: `${prefix}-asryz`,
    path: "tool/asryz",
    meta: { title: "语种识别" },
    component: () => import("@/views/tools/audio/FunAsrRealtimeyz.vue"),
  },
  {
    name: `${prefix}-realtime`,
    path: "tool/realtime",
    meta: { title: "智能语音助手" },
    component: () => import("@/views/tools/audio/DoubaoRealtime.vue"),
  },
  {
    name: `${prefix}-voice-clone`,
    path: "tool/voice-clone",
    meta: { title: "声音克隆" },
    component: () => import("@/views/tools/audio/VoiceClone.vue"),
  },
  {
    name: `${prefix}-audio-visualizer`,
    path: "tool/audio-visualizer",
    meta: { title: "声音可视化" },
    component: () => import("@/views/tools/audio/AudioVisualizer.vue"),
  },
  {
    name: `${prefix}-sound-lab`,
    path: "tool/sound-lab",
    meta: { title: "声学实验室" },
    component: () => import("@/views/tools/audio/SoundLab.vue"),
  },
  {
    name: `${prefix}-wake-lab`,
    path: "tool/wake-lab",
    meta: { title: "唤醒实验室" },
    component: () => import("@/views/tools/audio/WakeLab.vue"),
  },
  {
    name: `${prefix}-voiceprint`,
    path: "tool/voiceprint",
    meta: { title: "声纹密码" },
    component: () => import("@/views/tools/audio/VoicePrint.vue"),
  },

  // 视频工具
  {
    name: `${prefix}-video`,
    path: "tool/video",
    meta: { title: "视频生成" },
    component: () => import("@/views/tools/video/VideoGeneration.vue"),
  },

  // 音乐工具
  {
    name: `${prefix}-music`,
    path: "tool/music",
    meta: { title: "音乐生成" },
    component: () => import("@/views/tools/music/MusicGeneration.vue"),
  },

  {
    name: `${prefix}-jupyter`,
    path: "tool/jupyter",
    meta: { title: "Jupyter" },
    component: () => import("@/views/tools/misc/JupyterHub.vue"),
  },
  {
    name: `${prefix}-vibe-coding`,
    path: "tool/vibe-coding",
    meta: { title: "氛围编程" },
    component: () => import("@/views/tools/code/VibeCoding.vue"),
  },

    // 游戏工具
  {
    name: `${prefix}-gomoku`,
    path: "tool/gomoku",
    meta: { title: "AI五子棋" },
    component: () => import("@/views/tools/game/Gomoku.vue"),
  },
  {
    name: `${prefix}-sokoban`,
    path: "tool/sokoban",
    meta: { title: "语音推箱子" },
    component: () => import("@/views/tools/game/Sokoban.vue"),
  },
];

// 学生路由配置
export const studentRoutes = [
  {
    path: "/student",
    name: "student-nav",
    meta: { title: "海牛AI实验室" },
    component: () => import("@/views/student/StudentNav.vue"),
  },
  {
    path: "/student/login",
    name: "student-login",
    meta: { title: "学生登录" },
    component: () => import("@/views/student/StudentLogin.vue"),
  },
  {
    path: "/student/register",
    name: "student-register",
    meta: { title: "学生注册" },
    component: () => import("@/views/student/StudentRegister.vue"),
  },
  {
    path: "/student/join",
    name: "student-join",
    meta: { title: "加入班级" },
    component: () => import("@/views/student/JoinRoom.vue"),
  },
  {
    path: "/student",
    name: "student-home",
    redirect: "/student/tool",
    meta: {
      title: "学生中心",
      requiresAuth: true,
      roles: ["student"],
    },
    component: () => import("@/views/student/StudentHome.vue"),
    children: [
      ...toolRoutes,
      {
        name: "student-AI",
        path: "/student/tool",
        meta: { title: "AI工具" },
        component: () => import("@/views/educator/MyTools.vue"),
      },
      // {
      //   name: "student-tools",
      //   path: "/student/tools",
      //   meta: { title: "AI Chat" },
      //   component: () => import("@/views/student/MyTools.vue"),
      // },
      {
        name: "student-works",
        path: "/student/works",
        meta: { title: "我的作品" },
        component: () => import("@/views/student/MyWorks.vue"),
      },
      {
        name: "student-courses",
        path: "/student/courses",
        meta: { title: "AI课程" },
        component: () => import("@/views/student/MyCourses.vue"),
      },
      {
        name: "student-train-model",
        path: "/student/train-model",
        meta: { title: "AI体验" },
        component: () => import("@/views/tools/training/TrainModel.vue"),
      },

      // 数据标注
      {
        name: `${prefix}-train-ocean`,
        path: "tool/train-ocean",
        meta: { title: "海洋工程" },
        component: () => import("@/views/tools/training/TrainOcean.vue"),
      },
      {
        name: `${prefix}-training`,
        path: "tool/training",
        meta: { title: "数据标注" },
        component: () => import("@/views/tools/training/Training.vue"),
      },

      {
        name: "student-agent-hub",
        path: "/student/agent-hub",
        meta: { title: "AI智能体" },
        component: () => import("@/views/educator/AgentHub.vue"),
      },

      {
        path: "/student/course/detail",
        name: "student-course-detail",
        meta: { title: "课程详情" },
        component: () => import("@/views/educator/course/CourseDetail.vue"),
      },
      {
        path: "/student/lesson/detail",
        name: "student-lesson-detail",
        meta: { title: "视频详情" },
        component: () => import("@/views/educator/course/LessonDetail.vue"),
      },
    ],
  },
];
